import Menu from "./layouts/menu";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { rutasRouter } from "./routeConfig";
import { AuthenticatedTemplate, MsalProvider } from '@azure/msal-react';
import { IPublicClientApplication } from "@azure/msal-browser";
import { ToastContextProvider } from "./context/toastContext";
import Footer from "./layouts/footer";
import { AxiosInterceptor } from "./interceptors/axiosInstance";
import { LoaderContextProvider } from "./context/loaderContext";
import { FloatingButtonProvider } from "./context/floatingContext";
import TopBar from "./layouts/topbar/topBar";
import { DetalleMutuoProvider } from "./context/mutuoContext";
import { TopBarProvider } from "./context/topbarContext"
import { ValidadorAsientosContablesProvider } from "./context/validadorAsientosContablesContext";
import { RecaudacionProvider } from "./context/recaudacionContext";
import { DetalleTablaDesarrolloProvider } from "./context/tablaDesarrolloContext";
import { UserRolesProvider } from "./context/userRolesContext";

const MainContent = () => {

    return (
        <Router>
            <UserRolesProvider>
            <ToastContextProvider>
                <LoaderContextProvider>
                    <FloatingButtonProvider>
                        <AxiosInterceptor></AxiosInterceptor>
                        <Menu />
                        <AuthenticatedTemplate>
                            <RecaudacionProvider>
                                <DetalleMutuoProvider>
                                    <ValidadorAsientosContablesProvider>
                                        <DetalleTablaDesarrolloProvider>
                                            <TopBarProvider>
                                                <main id="main" className="main">
                                                    <TopBar />
                                                    <Routes>
                                                        {rutasRouter.map((route, index) => (
                                                            <Route key={index} path={route.path} element={route.element} />
                                                        ))}
                                                    </Routes>
                                                </main>
                                            </TopBarProvider>
                                        </DetalleTablaDesarrolloProvider>
                                    </ValidadorAsientosContablesProvider>
                                </DetalleMutuoProvider>
                            </RecaudacionProvider>
                        </AuthenticatedTemplate>
                    </FloatingButtonProvider>
                </LoaderContextProvider>
            </ToastContextProvider>
            </UserRolesProvider>
        </Router >
    );
};

type AppProps = {
    instance: IPublicClientApplication;
};

const App = ({ instance }: AppProps) => {
    return (
        <MsalProvider instance={instance}>
            <MainContent />
            <Footer />
        </MsalProvider>
    );
};

export default App;
